<template>
  <div class="Prices">
      Add Funds with PayPal
  </div>
</template>

<script>
export default {
  props: ["price", "account"]
}
</script>
